import { token } from '@/infrastructure/container';
import type { ProjectState } from '@/domain/project';
import type { SessionState } from '@/domain/session';

// The facade the admin's report screen talks to, pinned by session/contracts/p5-reporting.md. The
// real implementation sits over @celeriant/sdk; tests hand the store an in-memory one.
//
// STUB. P5's implementation fills this in. The interface is the frozen part.

export interface IReportGateway {
  // Opens and folds one session aggregate for READING. No redeem: the admin laptop already owns
  // the project and the sessions it scheduled (docs/access.md), and the report is read days later
  // from the project view, not from a role screen.
  //
  // Resolves with the folded state. Rejects translated into the taxonomy ('@/domain/errors'):
  // ServerError, OfflineError, NotFoundError, ForbiddenError, UpdateRequiredError. The store
  // catches all of them and surfaces one sentence; nothing rejects out of the store to a view.
  loadSession(sessionId: string): Promise<SessionState>;
  // The day's run list, live. MobX observable, so a session scheduled on another device appears in
  // the report picker without a reload.
  readonly projectState: ProjectState;
}

export const TOKEN_IReportGateway = token<IReportGateway>('IReportGateway');
